const approvalStatuses = {
  not_submitted: { id: 'not_submitted', name: 'Not Submitted' },
  pending_approval: { id: 'pending_approval', name: 'Pending Approval' },
  approved: { id: 'approved', name: 'Approved' },
  rejected: { id: 'rejected', name: 'Rejected' },
};

export default approvalStatuses;
